<div *ngIf="showViewHTMLComponent">
  <div *ngIf="originalData.length > 0">
    <div class="search-results-bar">
      <input type="text" class="search-input-results" (input)="applyFilter()" placeholder="Buscar" name="filtro"
        [(ngModel)]="filterTerm">
      <button class="search-button" (click)="applyFilter()">
        <span class="material-symbols-outlined">
          search
        </span>
      </button>
    </div>
    <div id="data-table-component" class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>
              <div (click)="sortTable('vigencia')">
                <span>Años</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'vigencia' && this.sortDirection == 'asc'">arrow_upward_alt</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'vigencia' && this.sortDirection == 'desc'">arrow_downward_alt</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy !== 'vigencia'">unfold_more</span>
              </div>
            </th>
            <th>
              <div (click)="sortTable('nombrePeriodo')">
                <span>Periodo</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'nombrePeriodo' && this.sortDirection == 'asc'">arrow_upward_alt</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'nombrePeriodo' && this.sortDirection == 'desc'">arrow_downward_alt</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy !== 'nombrePeriodo'">unfold_more</span>
              </div>
            </th>
            <th>
              <div (click)="sortTable('nroReferencia')">
                <span>No. de referencia</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'nroReferencia' && this.sortDirection == 'asc'">arrow_upward_alt</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'nroReferencia' && this.sortDirection == 'desc'">arrow_downward_alt</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy !== 'nroReferencia'">unfold_more</span>
              </div>
            </th>
            <th>
              <div (click)="sortTable('nroTransaccion')">
                <span>No. de transacción</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'nroTransaccion' && this.sortDirection == 'asc'">arrow_upward_alt</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'nroTransaccion' && this.sortDirection == 'desc'">arrow_downward_alt</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy !== 'nroTransaccion'">unfold_more</span>
              </div>
            </th>
            <th>
              <div (click)="sortTable('nomBanco')">
                <span>Entidad financiera</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'nomBanco' && this.sortDirection == 'asc'">arrow_upward_alt</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'nomBanco' && this.sortDirection == 'desc'">arrow_downward_alt</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy !== 'nomBanco'">unfold_more</span>
              </div>
            </th>
            <th>
              <div (click)="sortTable('fechaPresentacion')">
                <span>Fecha de presentación</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'fechaPresentacion' && this.sortDirection == 'asc'">arrow_upward_alt</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'fechaPresentacion' && this.sortDirection == 'desc'">arrow_downward_alt</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy !== 'fechaPresentacion'">unfold_more</span>
              </div>
            </th>
            <th>
              <div (click)="sortTable('indPago')">
                <span>Indicador de pago</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'indPago' && this.sortDirection == 'asc'">arrow_upward_alt</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'indPago' && this.sortDirection == 'desc'">arrow_downward_alt</span>
                <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy !== 'indPago'">unfold_more</span>
              </div>
            </th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of paginatedData">
            <td>{{item.vigencia}}</td>
            <td>{{item.nombrePeriodo}}</td>
            <td>{{item.nroReferencia }}</td>
            <td>{{item.nroTransaccion }}</td>
            <td>{{item.nomBanco }}</td>
            <td>{{item.fechaPresentacion}}</td>
            <td>{{item.indPago}}</td>
            <td>
              <div class="cell-table-actions">
                <a href="javascript:void(0)" class="a-action-primary" (click)="printCertification(item.idSoporteTributario)">Descargar</a>
              </div>
            </td>
          </tr>
          <tr *ngIf="paginatedData.length == 0 && originalData.length > 0" >
            <td colspan="7" style="text-align: center;">
              No se encontraron resultados asociados a tu búsqueda.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="pagination" *ngIf="pageNumbers.length != 0 && this.originalData.length > this.rowsPerPage">
      <span class="pagination-text control_boton_paginacion_1" (click)="prevPage()"
        [ngClass]="{ 'enabled-control-button' : currentPage !== 1 }">Anterior</span>
      <span class="pagination-text material-symbols-outlined material-symbols-filled control_boton_paginacion_2" (click)="prevPage()"
        [ngClass]="{ 'enabled-control-button' : currentPage !== 1 }">arrow_back_ios</span>
      <ng-container *ngFor="let page of pageNumbers">
        <button *ngIf="page !== '...'; else ellipsis" class="page-button" [class.active]="page === currentPage"
          (click)="goToPage(page)"> {{page}}</button>
        <span>
        </span>
        <ng-template #ellipsis>
          <span class="ellipsis enabled-control-button w700">...</span>
        </ng-template>
      </ng-container>
      <span class="pagination-text control_boton_paginacion_1" (click)="nextPage()"
        [ngClass]="{ 'enabled-control-button' : currentPage !== totalPages && totalPages !== 0 }">Siguiente</span>
      <span class="pagination-text material-symbols-outlined material-symbols-filled control_boton_paginacion_2" (click)="nextPage()"
        [ngClass]="{ 'enabled-control-button' : currentPage !== totalPages && totalPages !== 0 }">arrow_forward_ios</span>
    </div>
  </div>
  <div class="container-body-tab-item-result" *ngIf="originalData.length == 0">
    <div class="container-body-tab-item-result-view">
      <span class="material-symbols-outlined material-symbols-filled header-icon alert-info">event_available</span>
      <p class="header-icon-title alert-info" >Sin pagos ni declaraciones registradas</p>
      <p class="body-seccion">Aún no has presentado declaraciones ni realizado pagos.<br>Cuando presentes o pagues una obligación, verás aquí el detalle de cada transacción.</p>
    </div>
  </div>
</div>